import {
  FETCH_PLANOGRAM_TEMPLATE,
  RESET_PLANOGRAM_TEMPLATE,
} from "../../constants/action.constants";

const initialState = {
  data: {},
};

const planogramTemplateView = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PLANOGRAM_TEMPLATE:
      return { data: action.payload };
    case RESET_PLANOGRAM_TEMPLATE:
      return initialState;
    default:
      return state;
  }
};

export default planogramTemplateView;
